var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h192v192H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.84 109.93 54.96 167.87c-10.68 6.07-23.94-1.64-23.94-13.93V38.06c0-12.29 13.26-20 23.94-13.93l101.88 57.94c10.8 6.14 10.8 21.71 0 27.85Z",
    style: {
      stroke: "#ffffff",
      strokeMiterlimit: 10,
      strokeWidth: 12,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 33 88 90m-88 34.61L124 67",
    style: {
      fill: "none",
      strokeLinecap: "round",
      stroke: "#ffffff",
      strokeMiterlimit: 10,
      strokeWidth: 12
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/play-store-logo.82c4b71aa3e28707ab70eead9a66d8ab.svg";
export { ForwardRef as ReactComponent };